var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleOutlineOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1252 10.5C24.9421 13.0419 23.0565 15 21.0002 15C18.944 15 17.0552 13.0425 16.8752 10.5C16.6877 7.85562 18.5234 6 21.0002 6C23.4771 6 25.3127 7.90375 25.1252 10.5Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 19C16.9271 19 13.0102 21.0231 12.029 24.9631C11.899 25.4844 12.2259 26 12.7615 26H29.2396C29.7752 26 30.1002 25.4844 29.9721 24.9631C28.9909 20.96 25.074 19 21.0002 19Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 11.6213C12.3541 13.6513 10.8303 15.25 9.18785 15.25C7.54535 15.25 6.0191 13.6519 5.87535 11.6213C5.72598 9.50938 7.2091 8 9.18785 8C11.1666 8 12.6497 9.54813 12.5003 11.6213Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8749 19.1248C11.7468 18.6079 10.5043 18.4092 9.18738 18.4092C5.93738 18.4092 2.80613 20.0248 2.02175 23.1717C1.91863 23.5879 2.17988 23.9998 2.60738 23.9998H9.62488",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleOutlineOrange);
export default __webpack_public_path__ + "static/media/peopleOutlineOrange.10f7accdebc07cc3dc98c456743cb533.svg";
export { ForwardRef as ReactComponent };